import React from 'react';
import EIVHeader  from './EIVHeader';
import { Button, Form, FormGroup, Label } from 'reactstrap';
import Switch from "react-switch";
import { connect } from 'react-redux';
import { GIT_COMMIT_HASH } from "./git-commit-hash";
import { setScreen, appScreens, aktiviereLokalesSpeichern, deaktiviereLokalesSpeichern,
	setDisplayMode } from './store/appNavigation/actions';
import { DISPLAY_MODES, DISPLAY_MODE_AUTO, systemBevorzugtDunkel } from './displayMode';

// Bootstrap 5 kennt kein Jumbotron mehr; die Doku empfiehlt genau diese Klassen.
const KLASSEN_PANEL = "p-4 p-sm-5 mb-4 bg-body rounded-3";

 function StartPage(props) {
	const  { aktiviereSpeichern, deaktiviereSpeichern, saveStateToLocalStorage = false,
		displayMode = DISPLAY_MODE_AUTO, setDisplayMode } = props
	// Ein blockierter localStorage (privates Fenster, "Cookies blockieren", Quota) liess den
	// Schalter bisher wortlos aus stehen. Jetzt steht daneben, warum.
	const [speichernFehlgeschlagen, setSpeichernFehlgeschlagen] = React.useState(false)
	// Bei "Automatisch" ist nicht ablesbar, was gerade gilt - deshalb ausgeschrieben.
	const hinweisDarstellung = displayMode === DISPLAY_MODE_AUTO
		? `Folgt dem Betriebssystem – dort ist derzeit ${systemBevorzugtDunkel() ? 'dunkel' : 'hell'} eingestellt.`
		: 'Feste Wahl, unabhängig vom Betriebssystem.';
	return (
		<div className="container">
			<EIVHeader></EIVHeader>
			<div className={KLASSEN_PANEL}>
			<h1 className="display-4">Willkommen!</h1>
			<p className="lead">
				Als Veranstalter einer anerkannten Fortbildung melden Sie hier die Teilnahmen und
				Punkte Ihrer Teilnehmer.
			</p>
			{/* "(als Veranstalter)" stammt aus der Zeit, als die App zwei Zielgruppen hatte; den
			    Teilnehmer-Ast gibt es seit Juli 2026 nicht mehr, die Klammer unterschied nichts. */}
			<Button className="mt-5 mb-4" onClick={e => props.setScreen(appScreens.veranstalterPage)} block size="lg" color="info">Zur Punktemeldung</Button>
			<Form>
				<FormGroup>
					<Label check>
						<Switch onColor="#138496" onChange={() => { saveStateToLocalStorage
							? deaktiviereSpeichern()
							: setSpeichernFehlgeschlagen(!aktiviereSpeichern()) }} checked={saveStateToLocalStorage} />
						<span className="mx-2 lead">Daten lokal im Browser speichern</span>
					</Label>
					{ speichernFehlgeschlagen &&
						<div className="small text-danger-emphasis mt-1">
							<b>Dieser Browser lässt das Speichern nicht zu.</b>
						</div>
					}
				</FormGroup>
				{/* Steht bewusst neben der lokalen Speicherung: beides sind Einstellungen
				    dieses Geraets, und die eine bestimmt, ob die andere erhalten bleibt. */}
				<FormGroup>
					<div className="lead mb-2">Darstellung</div>
					<div className="btn-group" role="group" aria-label="Darstellung">
						{DISPLAY_MODES.map((modus) => (
							<button key={modus.value} type="button"
								className={"btn " + (displayMode === modus.value ? "btn-info" : "btn-outline-info")}
								aria-pressed={displayMode === modus.value}
								onClick={() => setDisplayMode(modus.value)}>{modus.title}</button>
						))}
					</div>
					<div className="mt-2">
						<small className="text-body-secondary">{hinweisDarstellung}</small>
						{ !saveStateToLocalStorage &&
							<small className="text-body-secondary d-block">Ohne lokale Speicherung gilt die Wahl nur für diesen Besuch.</small>
						}
					</div>
				</FormGroup>
			</Form>
			</div>
			<div className={KLASSEN_PANEL}>
			{/* Zwei Saetze statt sechs, und dieselben Worte wie im SpeichermodusHinweis: "Neuladen
			    oder Schliessen" ist woertlich zu nehmen, ein F5 raeumt genauso ab. Die erfundenen
			    Namen "Modus fuer private Geraete / oeffentliche Rechner" sind weg - der Schalter
			    darueber heisst anders, und zwei Vokabulare fuer eine Sache erklaeren nichts. */}
			{ saveStateToLocalStorage &&
				<p className="lead">
					Ihre Veranstaltungen, erfasste Teilnahmen und eingetragene Namen liegen im Speicher
					dieses Browsers und sind beim nächsten Besuch wieder da. Gedacht für Ihr eigenes Gerät.
				</p>
			}
			{ !saveStateToLocalStorage &&
			<p className="lead">
				Auf diesem Gerät wird nichts gespeichert: Beim Neuladen oder Schließen der Seite gehen
				geladene Veranstaltungen und erfasste Teilnahmen verloren. An einem öffentlichen Rechner
				ist das richtig so – auf Ihrem eigenen Gerät schalten Sie die Speicherung oben ein.
			</p>
			}
			<div className='text-end mb-2'>
				<small className='text-muted'>git commit hash: {GIT_COMMIT_HASH}</small>
			</div>
			</div>
		</div>
	);
}
const putStateToProps = (state) => {
	return { 
		saveStateToLocalStorage : state.appNavigation.saveStateToLocalStorage,
		displayMode : state.appNavigation.displayMode,
	};
}
const putActionsToProps = dispatch => {
	return {
		setScreen : (screen) => dispatch(setScreen(screen)),
		aktiviereSpeichern: () => dispatch(aktiviereLokalesSpeichern()),
		deaktiviereSpeichern: () => dispatch(deaktiviereLokalesSpeichern()),
		setDisplayMode: (modus) => dispatch(setDisplayMode(modus))
	}
};

const WrappedStartPage = connect(putStateToProps, putActionsToProps)(StartPage);
export default WrappedStartPage;
